module.exports = {
	"2": {
		"0": {
			"73": [
				73
			],
			"102": [
				102
			],
			"257": [
				257
			],
			"307": [
				307
			],
			"318": [
				318
			],
			"352": [
				352
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"752": [
				743
			],
			"753": [
				744
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"122": [
				122
			],
			"129": [
				129
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"366": [
				366
			],
			"566": [
				557
			],
			"616": [
				607
			],
			"872": [
				863
			],
			"894": [
				885
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"123": [
				123
			],
			"130": [
				130
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"367": [
				367
			],
			"567": [
				558
			],
			"617": [
				608
			],
			"873": [
				864
			],
			"895": [
				886
			]
		},
		"3": {
			"23": [
				23
			],
			"85": [
				85
			],
			"124": [
				124
			],
			"131": [
				131
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"368": [
				368
			],
			"568": [
				559
			],
			"618": [
				609
			],
			"874": [
				865
			],
			"896": [
				887
			]
		},
		"4": {
			"24": [
				24
			],
			"86": [
				86
			],
			"125": [
				125
			],
			"132": [
				132
			],
			"141": [
				141
			],
			"185": [
				185
			],
			"198": [
				198
			],
			"369": [
				369
			],
			"569": [
				560
			],
			"619": [
				610
			],
			"875": [
				866
			],
			"897": [
				888
			]
		},
		"5": {
			"25": [
				25
			],
			"87": [
				87
			],
			"126": [
				126
			],
			"133": [
				133
			],
			"142": [
				142
			],
			"186": [
				186
			],
			"199": [
				199
			],
			"370": [
				370
			],
			"570": [
				561
			],
			"620": [
				611
			],
			"876": [
				867
			],
			"898": [
				889
			]
		},
		"6": {
			"26": [
				26
			],
			"88": [
				88
			],
			"127": [
				127
			],
			"134": [
				134
			],
			"143": [
				143
			],
			"187": [
				187
			],
			"200": [
				200
			],
			"371": [
				371
			],
			"571": [
				562
			],
			"621": [
				612
			],
			"877": [
				868
			],
			"899": [
				890
			]
		},
		"7": {
			"27": [
				27
			],
			"89": [
				89
			],
			"128": [
				128
			],
			"135": [
				135
			],
			"144": [
				144
			],
			"188": [
				188
			],
			"201": [
				201
			],
			"372": [
				372
			],
			"572": [
				563
			],
			"622": [
				613
			],
			"878": [
				869
			],
			"900": [
				891
			]
		}
	},
	"3": {
		"0": {
			"73": [
				73
			],
			"74": [
				74
			],
			"102": [
				102
			],
			"257": [
				257
			],
			"307": [
				307
			],
			"318": [
				318
			],
			"352": [
				352
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"746": [
				737
			],
			"891": [
				882
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"366": [
				366
			],
			"566": [
				557
			],
			"616": [
				607
			],
			"797": [
				788
			],
			"800": [
				791
			],
			"851": [
				842
			],
			"854": [
				845
			],
			"857": [
				848
			],
			"905": [
				896
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"367": [
				367
			],
			"567": [
				558
			],
			"617": [
				608
			],
			"798": [
				789
			],
			"801": [
				792
			],
			"852": [
				843
			],
			"855": [
				846
			],
			"858": [
				849
			],
			"906": [
				897
			]
		},
		"3": {
			"23": [
				23
			],
			"85": [
				85
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"368": [
				368
			],
			"568": [
				559
			],
			"618": [
				609
			],
			"799": [
				790
			],
			"802": [
				793
			],
			"853": [
				844
			],
			"856": [
				847
			],
			"859": [
				850
			],
			"907": [
				898
			]
		},
		"4": {
			"17": [
				17
			],
			"176": [
				176
			],
			"362": [
				362
			]
		},
		"5": {
			"13": [
				13
			],
			"172": [
				172
			],
			"358": [
				358
			]
		},
		"6": {
			"18": [
				18
			],
			"177": [
				177
			],
			"363": [
				363
			]
		},
		"7": {
			"14": [
				14
			],
			"173": [
				173
			],
			"359": [
				359
			]
		}
	},
	"4": {
		"0": {
			"73": [
				73
			],
			"74": [
				74
			],
			"102": [
				102
			],
			"137": [
				137
			],
			"257": [
				257
			],
			"281": [
				281
			],
			"307": [
				307
			],
			"318": [
				318
			],
			"319": [
				319
			],
			"320": [
				320
			],
			"352": [
				352
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"764": [
				755
			],
			"807": [
				798
			],
			"891": [
				882
			],
			"936": [
				927
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"366": [
				366
			],
			"566": [
				557
			],
			"616": [
				607
			],
			"845": [
				836
			],
			"905": [
				896
			],
			"912": [
				903
			],
			"918": [
				909
			],
			"923": [
				914
			],
			"929": [
				920
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"367": [
				367
			],
			"567": [
				558
			],
			"617": [
				608
			],
			"846": [
				837
			],
			"906": [
				897
			],
			"913": [
				904
			],
			"919": [
				910
			],
			"924": [
				915
			],
			"930": [
				921
			]
		},
		"3": {
			"23": [
				23
			],
			"85": [
				85
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"368": [
				368
			],
			"568": [
				559
			],
			"618": [
				609
			],
			"847": [
				838
			],
			"907": [
				898
			],
			"914": [
				905
			],
			"920": [
				911
			],
			"925": [
				916
			],
			"931": [
				922
			]
		},
		"4": {
			"24": [
				24
			],
			"86": [
				86
			],
			"141": [
				141
			],
			"185": [
				185
			],
			"198": [
				198
			],
			"369": [
				369
			],
			"569": [
				560
			],
			"619": [
				610
			],
			"848": [
				839
			],
			"908": [
				899
			],
			"915": [
				906
			],
			"921": [
				912
			],
			"926": [
				917
			],
			"932": [
				923
			]
		},
		"5": {
			"25": [
				25
			],
			"87": [
				87
			],
			"142": [
				142
			],
			"186": [
				186
			],
			"199": [
				199
			],
			"370": [
				370
			],
			"570": [
				561
			],
			"620": [
				611
			],
			"849": [
				840
			],
			"909": [
				900
			],
			"916": [
				907
			],
			"922": [
				913
			],
			"927": [
				918
			],
			"933": [
				924
			]
		},
		"6": {
			"26": [
				26
			],
			"88": [
				88
			],
			"143": [
				143
			],
			"187": [
				187
			],
			"200": [
				200
			],
			"371": [
				371
			],
			"571": [
				562
			],
			"910": [
				901
			],
			"917": [
				908
			],
			"928": [
				919
			],
			"934": [
				925
			]
		},
		"7": {
			"17": [
				17
			],
			"176": [
				176
			],
			"362": [
				362
			]
		},
		"8": {
			"13": [
				13
			],
			"172": [
				172
			],
			"358": [
				358
			]
		},
		"9": {
			"18": [
				18
			],
			"177": [
				177
			],
			"363": [
				363
			]
		},
		"10": {
			"14": [
				14
			],
			"173": [
				173
			],
			"359": [
				359
			]
		},
		"11": {
			"19": [
				19
			],
			"178": [
				178
			],
			"364": [
				364
			]
		},
		"12": {
			"15": [
				15
			],
			"174": [
				174
			],
			"360": [
				360
			]
		},
		"13": {
			"20": [
				20
			],
			"179": [
				179
			],
			"365": [
				365
			]
		},
		"14": {
			"16": [
				16
			],
			"175": [
				175
			],
			"361": [
				361
			]
		}
	},
	"5": {
		"0": {
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"698": [
				689
			]
		}
	},
	"6": {
		"0": {
			"73": [
				73
			],
			"82": [
				82
			],
			"102": [
				102
			],
			"257": [
				257
			],
			"296": [
				296
			],
			"297": [
				297
			],
			"298": [
				298
			],
			"299": [
				299
			],
			"305": [
				305
			],
			"307": [
				307
			],
			"308": [
				308
			],
			"309": [
				309
			],
			"315": [
				315
			],
			"318": [
				318
			],
			"320": [
				320
			],
			"328": [
				328
			],
			"329": [
				329
			],
			"330": [
				330
			],
			"331": [
				331
			],
			"332": [
				332
			],
			"337": [
				337
			],
			"338": [
				338
			],
			"339": [
				339
			],
			"340": [
				340
			],
			"341": [
				341
			],
			"342": [
				342
			],
			"352": [
				352
			],
			"403": [
				403
			],
			"427": [
				427
			],
			"443": [
				443
			],
			"445": [
				445
			],
			"455": [
				1861
			],
			"456": [
				1861
			],
			"457": [
				1861
			],
			"458": [
				1861
			],
			"459": [
				1861
			],
			"460": [
				1861
			],
			"512": [
				1871
			],
			"513": [
				1871
			],
			"514": [
				505
			],
			"515": [
				506
			],
			"516": [
				507
			],
			"522": [
				513
			],
			"523": [
				514
			],
			"536": [
				527
			],
			"543": [
				534
			],
			"544": [
				535
			],
			"545": [
				536
			],
			"546": [
				537
			],
			"547": [
				538
			],
			"548": [
				539
			],
			"549": [
				540
			],
			"550": [
				1870
			],
			"551": [
				1870
			],
			"552": [
				543
			],
			"553": [
				544
			],
			"559": [
				550
			],
			"560": [
				551
			],
			"608": [
				599
			],
			"632": [
				623
			],
			"636": [
				627
			],
			"647": [
				638
			],
			"696": [
				687
			],
			"697": [
				688
			],
			"722": [
				713
			],
			"741": [
				732
			],
			"748": [
				739
			],
			"807": [
				798
			],
			"901": [
				1872
			],
			"902": [
				1872
			],
			"903": [
				894
			]
		},
		"1": {
			"21": [
				21
			],
			"76": [
				76
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"190": [
				190
			],
			"195": [
				195
			],
			"300": [
				300
			],
			"310": [
				310
			],
			"333": [
				333
			],
			"366": [
				366
			],
			"517": [
				508
			],
			"554": [
				545
			],
			"561": [
				552
			],
			"566": [
				557
			],
			"603": [
				594
			],
			"627": [
				618
			],
			"717": [
				708
			],
			"754": [
				745
			],
			"759": [
				750
			],
			"768": [
				759
			],
			"905": [
				896
			]
		},
		"2": {
			"22": [
				22
			],
			"77": [
				77
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"191": [
				191
			],
			"196": [
				196
			],
			"301": [
				301
			],
			"311": [
				311
			],
			"334": [
				334
			],
			"367": [
				367
			],
			"518": [
				509
			],
			"555": [
				546
			],
			"562": [
				553
			],
			"567": [
				558
			],
			"604": [
				595
			],
			"628": [
				619
			],
			"718": [
				709
			],
			"755": [
				746
			],
			"760": [
				751
			],
			"769": [
				760
			],
			"906": [
				897
			]
		},
		"3": {
			"23": [
				23
			],
			"78": [
				78
			],
			"85": [
				85
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"192": [
				192
			],
			"197": [
				197
			],
			"302": [
				302
			],
			"312": [
				312
			],
			"335": [
				335
			],
			"368": [
				368
			],
			"519": [
				510
			],
			"556": [
				547
			],
			"563": [
				554
			],
			"568": [
				559
			],
			"605": [
				596
			],
			"629": [
				620
			],
			"719": [
				710
			],
			"756": [
				747
			],
			"761": [
				752
			],
			"770": [
				761
			],
			"907": [
				898
			]
		},
		"4": {
			"24": [
				24
			],
			"79": [
				79
			],
			"86": [
				86
			],
			"141": [
				141
			],
			"185": [
				185
			],
			"193": [
				193
			],
			"198": [
				198
			],
			"303": [
				303
			],
			"313": [
				313
			],
			"336": [
				336
			],
			"369": [
				369
			],
			"520": [
				511
			],
			"557": [
				548
			],
			"564": [
				555
			],
			"569": [
				560
			],
			"606": [
				597
			],
			"630": [
				621
			],
			"720": [
				711
			],
			"757": [
				748
			],
			"762": [
				753
			],
			"771": [
				762
			],
			"908": [
				899
			]
		},
		"5": {
			"25": [
				25
			],
			"80": [
				80
			],
			"87": [
				87
			],
			"142": [
				142
			],
			"186": [
				186
			],
			"194": [
				194
			],
			"199": [
				199
			],
			"304": [
				304
			],
			"314": [
				314
			],
			"370": [
				370
			],
			"521": [
				512
			],
			"558": [
				549
			],
			"565": [
				556
			],
			"570": [
				561
			],
			"607": [
				598
			],
			"631": [
				622
			],
			"721": [
				712
			],
			"758": [
				749
			],
			"763": [
				754
			],
			"772": [
				763
			],
			"909": [
				900
			]
		}
	},
	"7": {
		"0": {
			"1": [
				1
			],
			"74": [
				74
			],
			"103": [
				103
			],
			"136": [
				136
			],
			"137": [
				137
			],
			"256": [
				256
			],
			"260": [
				260
			],
			"261": [
				261
			],
			"278": [
				278
			],
			"281": [
				281
			],
			"282": [
				282
			],
			"306": [
				306
			],
			"321": [
				321
			],
			"322": [
				322
			],
			"323": [
				323
			],
			"324": [
				324
			],
			"325": [
				325
			],
			"326": [
				326
			],
			"327": [
				327
			],
			"343": [
				343
			],
			"345": [
				345
			],
			"346": [
				346
			],
			"349": [
				349
			],
			"412": [
				412
			],
			"415": [
				415
			],
			"416": [
				416
			],
			"417": [
				417
			],
			"418": [
				418
			],
			"425": [
				425
			],
			"426": [
				426
			],
			"428": [
				428
			],
			"429": [
				429
			],
			"432": [
				432
			],
			"433": [
				433
			],
			"434": [
				434
			],
			"435": [
				435
			],
			"436": [
				436
			],
			"437": [
				437
			],
			"439": [
				439
			],
			"442": [
				442
			],
			"443": [
				443
			],
			"471": [
				462
			],
			"473": [
				464
			],
			"474": [
				465
			],
			"524": [
				515
			],
			"525": [
				516
			],
			"526": [
				517
			],
			"527": [
				518
			],
			"534": [
				525
			],
			"535": [
				526
			],
			"537": [
				528
			],
			"538": [
				529
			],
			"539": [
				530
			],
			"540": [
				531
			],
			"541": [
				532
			],
			"542": [
				533
			],
			"608": [
				599
			],
			"609": [
				600
			],
			"614": [
				605
			],
			"623": [
				614
			],
			"624": [
				615
			],
			"625": [
				616
			],
			"626": [
				617
			],
			"633": [
				624
			],
			"634": [
				625
			],
			"635": [
				626
			],
			"656": [
				647
			],
			"698": [
				689
			],
			"702": [
				693
			],
			"704": [
				695
			],
			"705": [
				696
			],
			"706": [
				697
			],
			"710": [
				701
			],
			"714": [
				705
			],
			"715": [
				706
			],
			"723": [
				714
			],
			"724": [
				715
			],
			"729": [
				720
			],
			"730": [
				721
			],
			"731": [
				722
			],
			"732": [
				723
			],
			"733": [
				724
			],
			"734": [
				725
			],
			"735": [
				726
			],
			"739": [
				730
			],
			"747": [
				738
			],
			"804": [
				795
			],
			"805": [
				796
			],
			"850": [
				841
			],
			"871": [
				862
			],
			"879": [
				870
			],
			"880": [
				871
			],
			"881": [
				872
			],
			"892": [
				883
			],
			"904": [
				895
			],
			"911": [
				902
			],
			"937": [
				928
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"273": [
				273
			],
			"419": [
				419
			],
			"528": [
				519
			],
			"657": [
				648
			],
			"673": [
				664
			],
			"707": [
				698
			],
			"736": [
				727
			],
			"738": [
				729
			],
			"740": [
				731
			],
			"743": [
				734
			],
			"765": [
				756
			],
			"803": [
				794
			],
			"869": [
				860
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"274": [
				274
			],
			"420": [
				420
			],
			"529": [
				520
			],
			"658": [
				649
			],
			"674": [
				665
			],
			"708": [
				699
			],
			"737": [
				728
			],
			"744": [
				735
			],
			"766": [
				757
			],
			"868": [
				859
			],
			"870": [
				861
			]
		},
		"3": {
			"2": [
				2
			],
			"148": [
				148
			],
			"154": [
				154
			],
			"160": [
				160
			],
			"650": [
				641
			],
			"661": [
				652
			]
		},
		"4": {
			"5": [
				5
			],
			"149": [
				149
			],
			"155": [
				155
			],
			"163": [
				163
			],
			"651": [
				642
			],
			"664": [
				655
			]
		},
		"5": {
			"7": [
				7
			],
			"150": [
				150
			],
			"156": [
				156
			],
			"165": [
				165
			],
			"652": [
				643
			],
			"666": [
				657
			]
		},
		"6": {
			"151": [
				151
			],
			"157": [
				157
			],
			"166": [
				166
			],
			"653": [
				644
			],
			"667": [
				658
			],
			"939": [
				930
			]
		},
		"7": {
			"9": [
				9
			],
			"152": [
				152
			],
			"158": [
				158
			],
			"168": [
				168
			],
			"654": [
				645
			],
			"669": [
				660
			]
		},
		"8": {
			"12": [
				12
			],
			"153": [
				153
			],
			"159": [
				159
			],
			"171": [
				171
			],
			"655": [
				646
			],
			"672": [
				663
			]
		},
		"9": {
			"66": [
				66
			],
			"255": [
				255
			],
			"354": [
				354
			],
			"355": [
				355
			],
			"438": [
				438
			],
			"689": [
				680
			]
		},
		"10": {
			"67": [
				67
			],
			"258": [
				258
			],
			"356": [
				356
			],
			"357": [
				357
			],
			"690": [
				681
			]
		},
		"11": {
			"81": [
				81
			],
			"353": [
				353
			],
			"440": [
				440
			],
			"441": [
				441
			],
			"699": [
				690
			]
		},
		"12": {
			"68": [
				68
			],
			"259": [
				259
			],
			"691": [
				682
			]
		},
		"13": {
			"69": [
				69
			],
			"146": [
				146
			],
			"180": [
				180
			],
			"262": [
				262
			],
			"659": [
				650
			],
			"692": [
				683
			],
			"703": [
				694
			],
			"749": [
				740
			]
		},
		"14": {
			"70": [
				70
			],
			"263": [
				263
			],
			"693": [
				684
			]
		},
		"15": {
			"72": [
				72
			],
			"277": [
				277
			],
			"695": [
				686
			]
		},
		"16": {
			"147": [
				147
			],
			"181": [
				181
			],
			"275": [
				275
			],
			"276": [
				276
			],
			"750": [
				741
			]
		}
	},
	"8": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			]
		},
		"1": {
			"195": [
				195
			],
			"673": [
				664
			]
		},
		"2": {
			"196": [
				196
			],
			"674": [
				665
			]
		},
		"3": {
			"197": [
				197
			],
			"675": [
				666
			]
		},
		"4": {
			"198": [
				198
			],
			"676": [
				667
			]
		}
	},
	"9": {
		"0": {
			"74": [
				74
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			]
		},
		"1": {
			"195": [
				195
			],
			"673": [
				664
			]
		},
		"2": {
			"196": [
				196
			],
			"674": [
				665
			]
		}
	},
	"10": {
		"0": {
			"1": [
				1
			],
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"11": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"12": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			]
		}
	},
	"13": {
		"0": {
			"283": [
				283
			],
			"284": [
				284
			],
			"285": [
				285
			],
			"286": [
				286
			],
			"287": [
				287
			],
			"288": [
				288
			],
			"289": [
				289
			],
			"290": [
				290
			],
			"291": [
				291
			],
			"292": [
				292
			],
			"293": [
				293
			],
			"294": [
				294
			],
			"295": [
				295
			],
			"316": [
				316
			],
			"461": [
				452
			],
			"462": [
				453
			],
			"463": [
				454
			],
			"464": [
				455
			],
			"465": [
				456
			],
			"466": [
				457
			],
			"467": [
				458
			],
			"468": [
				459
			],
			"469": [
				460
			],
			"470": [
				461
			]
		}
	},
	"14": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"15": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"16": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"17": {
		"0": {
			"348": [
				348
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"18": {
		"0": {
			"65": [
				65
			],
			"74": [
				74
			],
			"253": [
				253
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"350": [
				350
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"610": [
				601
			],
			"615": [
				606
			],
			"656": [
				647
			],
			"688": [
				679
			],
			"698": [
				689
			],
			"751": [
				742
			],
			"806": [
				797
			],
			"889": [
				880
			],
			"893": [
				884
			],
			"904": [
				895
			]
		},
		"1": {
			"21": [
				21
			],
			"195": [
				195
			],
			"673": [
				664
			],
			"707": [
				698
			],
			"743": [
				734
			]
		},
		"2": {
			"22": [
				22
			],
			"196": [
				196
			],
			"674": [
				665
			],
			"708": [
				699
			],
			"744": [
				735
			]
		},
		"3": {
			"23": [
				23
			],
			"197": [
				197
			],
			"675": [
				666
			],
			"709": [
				700
			],
			"745": [
				736
			]
		}
	},
	"19": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"615": [
				606
			],
			"698": [
				689
			],
			"723": [
				714
			],
			"911": [
				902
			]
		},
		"1": {
			"21": [
				21
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"673": [
				664
			],
			"882": [
				873
			],
			"884": [
				875
			],
			"886": [
				877
			]
		},
		"2": {
			"22": [
				22
			],
			"196": [
				196
			],
			"674": [
				665
			],
			"883": [
				874
			],
			"885": [
				876
			],
			"887": [
				878
			]
		}
	},
	"20": {
		"0": {
			"74": [
				74
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"698": [
				689
			]
		},
		"1": {
			"21": [
				21
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"673": [
				664
			],
			"860": [
				851
			]
		},
		"2": {
			"22": [
				22
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"674": [
				665
			],
			"861": [
				852
			]
		},
		"3": {
			"23": [
				23
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"675": [
				666
			],
			"862": [
				853
			]
		},
		"4": {
			"24": [
				24
			],
			"141": [
				141
			],
			"185": [
				185
			],
			"198": [
				198
			],
			"676": [
				667
			],
			"863": [
				854
			]
		},
		"5": {
			"25": [
				25
			],
			"142": [
				142
			],
			"186": [
				186
			],
			"199": [
				199
			],
			"677": [
				668
			],
			"864": [
				855
			]
		},
		"6": {
			"26": [
				26
			],
			"143": [
				143
			],
			"187": [
				187
			],
			"200": [
				200
			],
			"678": [
				669
			],
			"865": [
				856
			]
		},
		"7": {
			"27": [
				27
			],
			"144": [
				144
			],
			"188": [
				188
			],
			"201": [
				201
			],
			"679": [
				670
			],
			"866": [
				857
			]
		},
		"8": {
			"28": [
				28
			],
			"145": [
				145
			],
			"189": [
				189
			],
			"202": [
				202
			],
			"680": [
				671
			],
			"867": [
				858
			]
		}
	},
	"21": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"23": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"24": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"25": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"26": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"27": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"28": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"612": [
				603
			],
			"613": [
				604
			],
			"615": [
				606
			],
			"935": [
				926
			]
		}
	},
	"29": {
		"0": {
			"74": [
				74
			],
			"254": [
				254
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"195": [
				195
			],
			"366": [
				366
			],
			"475": [
				466
			],
			"566": [
				557
			],
			"808": [
				799
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"196": [
				196
			],
			"367": [
				367
			],
			"476": [
				467
			],
			"567": [
				558
			],
			"809": [
				800
			]
		},
		"3": {
			"23": [
				23
			],
			"85": [
				85
			],
			"197": [
				197
			],
			"368": [
				368
			],
			"477": [
				468
			],
			"568": [
				559
			],
			"810": [
				801
			]
		},
		"4": {
			"24": [
				24
			],
			"86": [
				86
			],
			"198": [
				198
			],
			"369": [
				369
			],
			"478": [
				469
			],
			"569": [
				560
			],
			"811": [
				802
			]
		},
		"5": {
			"25": [
				25
			],
			"87": [
				87
			],
			"199": [
				199
			],
			"370": [
				370
			],
			"479": [
				470
			],
			"570": [
				561
			],
			"812": [
				803
			]
		},
		"6": {
			"26": [
				26
			],
			"88": [
				88
			],
			"200": [
				200
			],
			"371": [
				371
			],
			"480": [
				471
			],
			"571": [
				562
			],
			"813": [
				804
			]
		},
		"7": {
			"27": [
				27
			],
			"89": [
				89
			],
			"201": [
				201
			],
			"372": [
				372
			],
			"481": [
				472
			],
			"572": [
				563
			],
			"814": [
				805
			]
		},
		"8": {
			"28": [
				28
			],
			"90": [
				90
			],
			"202": [
				202
			],
			"373": [
				373
			],
			"482": [
				473
			],
			"573": [
				564
			],
			"815": [
				806
			]
		},
		"9": {
			"29": [
				29
			],
			"91": [
				91
			],
			"203": [
				203
			],
			"374": [
				374
			],
			"483": [
				474
			],
			"574": [
				565
			],
			"816": [
				807
			]
		},
		"10": {
			"30": [
				30
			],
			"92": [
				92
			],
			"204": [
				204
			],
			"375": [
				375
			],
			"484": [
				475
			],
			"575": [
				566
			],
			"817": [
				808
			]
		},
		"11": {
			"31": [
				31
			],
			"93": [
				93
			],
			"205": [
				205
			],
			"376": [
				376
			],
			"485": [
				476
			],
			"576": [
				567
			],
			"818": [
				809
			]
		},
		"12": {
			"32": [
				32
			],
			"94": [
				94
			],
			"206": [
				206
			],
			"377": [
				377
			],
			"486": [
				477
			],
			"577": [
				568
			],
			"819": [
				810
			]
		},
		"13": {
			"33": [
				33
			],
			"95": [
				95
			],
			"207": [
				207
			],
			"378": [
				378
			],
			"487": [
				478
			],
			"578": [
				569
			],
			"820": [
				811
			]
		},
		"14": {
			"34": [
				34
			],
			"96": [
				96
			],
			"208": [
				208
			],
			"379": [
				379
			],
			"488": [
				479
			],
			"579": [
				570
			],
			"821": [
				812
			]
		},
		"15": {
			"35": [
				35
			],
			"97": [
				97
			],
			"209": [
				209
			],
			"380": [
				380
			],
			"489": [
				480
			],
			"580": [
				571
			],
			"822": [
				813
			]
		},
		"16": {
			"36": [
				36
			],
			"98": [
				98
			],
			"210": [
				210
			],
			"381": [
				381
			],
			"490": [
				481
			],
			"581": [
				572
			],
			"823": [
				814
			]
		},
		"17": {
			"37": [
				37
			],
			"99": [
				99
			],
			"211": [
				211
			],
			"382": [
				382
			],
			"491": [
				482
			],
			"582": [
				573
			],
			"824": [
				815
			]
		},
		"18": {
			"38": [
				38
			],
			"100": [
				100
			],
			"212": [
				212
			],
			"383": [
				383
			],
			"492": [
				483
			],
			"583": [
				574
			],
			"825": [
				816
			]
		},
		"19": {
			"39": [
				39
			],
			"101": [
				101
			],
			"213": [
				213
			],
			"384": [
				384
			],
			"493": [
				484
			],
			"584": [
				575
			],
			"826": [
				817
			]
		},
		"20": {
			"40": [
				40
			],
			"104": [
				104
			],
			"214": [
				214
			],
			"385": [
				385
			],
			"494": [
				485
			],
			"585": [
				576
			],
			"827": [
				818
			]
		},
		"21": {
			"41": [
				41
			],
			"105": [
				105
			],
			"215": [
				215
			],
			"386": [
				386
			],
			"495": [
				486
			],
			"586": [
				577
			],
			"828": [
				819
			]
		},
		"22": {
			"42": [
				42
			],
			"106": [
				106
			],
			"216": [
				216
			],
			"387": [
				387
			],
			"496": [
				487
			],
			"587": [
				578
			],
			"829": [
				820
			]
		},
		"23": {
			"43": [
				43
			],
			"107": [
				107
			],
			"217": [
				217
			],
			"388": [
				388
			],
			"497": [
				488
			],
			"588": [
				579
			],
			"830": [
				821
			]
		},
		"24": {
			"44": [
				44
			],
			"108": [
				108
			],
			"218": [
				218
			],
			"389": [
				389
			],
			"498": [
				489
			],
			"589": [
				580
			],
			"831": [
				822
			]
		},
		"25": {
			"45": [
				45
			],
			"109": [
				109
			],
			"219": [
				219
			],
			"390": [
				390
			],
			"499": [
				490
			],
			"590": [
				581
			],
			"832": [
				823
			]
		},
		"26": {
			"46": [
				46
			],
			"110": [
				110
			],
			"220": [
				220
			],
			"391": [
				391
			],
			"500": [
				491
			],
			"591": [
				582
			],
			"833": [
				824
			]
		},
		"27": {
			"47": [
				47
			],
			"111": [
				111
			],
			"221": [
				221
			],
			"392": [
				392
			],
			"501": [
				492
			],
			"592": [
				583
			],
			"834": [
				825
			]
		},
		"28": {
			"48": [
				48
			],
			"112": [
				112
			],
			"222": [
				222
			],
			"393": [
				393
			],
			"502": [
				493
			],
			"593": [
				584
			],
			"835": [
				826
			]
		},
		"29": {
			"49": [
				49
			],
			"113": [
				113
			],
			"223": [
				223
			],
			"394": [
				394
			],
			"503": [
				494
			],
			"594": [
				585
			],
			"836": [
				827
			]
		},
		"30": {
			"50": [
				50
			],
			"114": [
				114
			],
			"224": [
				224
			],
			"395": [
				395
			],
			"504": [
				495
			],
			"595": [
				586
			],
			"837": [
				828
			]
		},
		"31": {
			"51": [
				51
			],
			"115": [
				115
			],
			"225": [
				225
			],
			"396": [
				396
			],
			"505": [
				496
			],
			"596": [
				587
			],
			"838": [
				829
			]
		},
		"32": {
			"52": [
				52
			],
			"116": [
				116
			],
			"226": [
				226
			],
			"397": [
				397
			],
			"506": [
				497
			],
			"597": [
				588
			],
			"839": [
				830
			]
		},
		"33": {
			"53": [
				53
			],
			"117": [
				117
			],
			"227": [
				227
			],
			"398": [
				398
			],
			"507": [
				498
			],
			"598": [
				589
			],
			"840": [
				831
			]
		},
		"34": {
			"54": [
				54
			],
			"118": [
				118
			],
			"228": [
				228
			],
			"399": [
				399
			],
			"508": [
				499
			],
			"599": [
				590
			],
			"841": [
				832
			]
		},
		"35": {
			"55": [
				55
			],
			"119": [
				119
			],
			"229": [
				229
			],
			"400": [
				400
			],
			"509": [
				500
			],
			"600": [
				591
			],
			"842": [
				833
			]
		},
		"36": {
			"56": [
				56
			],
			"120": [
				120
			],
			"230": [
				230
			],
			"401": [
				401
			],
			"510": [
				501
			],
			"601": [
				592
			],
			"843": [
				834
			]
		},
		"37": {
			"57": [
				57
			],
			"121": [
				121
			],
			"231": [
				231
			],
			"402": [
				402
			],
			"511": [
				502
			],
			"602": [
				593
			],
			"844": [
				835
			]
		}
	},
	"30": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"256": [
				256
			],
			"279": [
				279
			],
			"306": [
				306
			],
			"343": [
				343
			],
			"344": [
				344
			],
			"346": [
				346
			],
			"347": [
				347
			],
			"349": [
				349
			],
			"350": [
				350
			],
			"403": [
				403
			],
			"412": [
				412
			],
			"415": [
				415
			],
			"426": [
				426
			],
			"443": [
				443
			],
			"446": [
				446
			],
			"447": [
				447
			],
			"448": [
				448
			],
			"449": [
				449
			],
			"450": [
				450
			],
			"451": [
				451
			],
			"524": [
				515
			],
			"535": [
				526
			],
			"608": [
				599
			],
			"610": [
				601
			],
			"611": [
				602
			],
			"615": [
				606
			],
			"626": [
				617
			],
			"634": [
				625
			],
			"637": [
				628
			],
			"656": [
				647
			],
			"698": [
				689
			],
			"706": [
				697
			],
			"710": [
				701
			],
			"711": [
				702
			],
			"712": [
				703
			],
			"713": [
				704
			],
			"751": [
				742
			],
			"889": [
				880
			],
			"904": [
				895
			],
			"911": [
				902
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"673": [
				664
			],
			"707": [
				698
			],
			"743": [
				734
			],
			"765": [
				756
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"674": [
				665
			],
			"708": [
				699
			],
			"744": [
				735
			],
			"766": [
				757
			]
		},
		"3": {
			"23": [
				23
			],
			"85": [
				85
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"675": [
				666
			],
			"709": [
				700
			],
			"745": [
				736
			],
			"767": [
				758
			]
		},
		"4": {
			"3": [
				3
			],
			"161": [
				161
			],
			"662": [
				653
			]
		},
		"5": {
			"4": [
				4
			],
			"162": [
				162
			],
			"663": [
				654
			]
		},
		"6": {
			"6": [
				6
			],
			"164": [
				164
			],
			"665": [
				656
			]
		},
		"7": {
			"8": [
				8
			],
			"167": [
				167
			],
			"668": [
				659
			]
		},
		"8": {
			"10": [
				10
			],
			"169": [
				169
			],
			"670": [
				661
			]
		},
		"9": {
			"11": [
				11
			],
			"170": [
				170
			],
			"671": [
				662
			]
		}
	},
	"31": {
		"0": {
			"60": [
				60
			],
			"74": [
				74
			],
			"103": [
				103
			],
			"137": [
				137
			],
			"242": [
				242
			],
			"243": [
				243
			],
			"244": [
				244
			],
			"245": [
				245
			],
			"247": [
				247
			],
			"256": [
				256
			],
			"280": [
				280
			],
			"281": [
				281
			],
			"306": [
				306
			],
			"317": [
				317
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"404": [
				404
			],
			"407": [
				407
			],
			"408": [
				408
			],
			"421": [
				421
			],
			"422": [
				422
			],
			"423": [
				423
			],
			"424": [
				424
			],
			"443": [
				443
			],
			"444": [
				444
			],
			"474": [
				465
			],
			"530": [
				521
			],
			"531": [
				522
			],
			"532": [
				523
			],
			"533": [
				524
			],
			"608": [
				599
			],
			"637": [
				628
			],
			"646": [
				637
			],
			"683": [
				674
			],
			"700": [
				691
			],
			"773": [
				764
			],
			"782": [
				773
			],
			"783": [
				774
			],
			"788": [
				779
			],
			"888": [
				879
			],
			"890": [
				881
			]
		},
		"1": {
			"21": [
				21
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"638": [
				629
			],
			"642": [
				633
			],
			"673": [
				664
			],
			"774": [
				765
			],
			"778": [
				769
			],
			"784": [
				775
			]
		},
		"2": {
			"22": [
				22
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"639": [
				630
			],
			"643": [
				634
			],
			"674": [
				665
			],
			"775": [
				766
			],
			"779": [
				770
			],
			"785": [
				776
			]
		},
		"3": {
			"23": [
				23
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"640": [
				631
			],
			"644": [
				635
			],
			"675": [
				666
			],
			"776": [
				767
			],
			"780": [
				771
			],
			"786": [
				777
			]
		},
		"4": {
			"24": [
				24
			],
			"141": [
				141
			],
			"185": [
				185
			],
			"198": [
				198
			],
			"641": [
				632
			],
			"645": [
				636
			],
			"676": [
				667
			],
			"777": [
				768
			],
			"781": [
				772
			],
			"787": [
				778
			]
		},
		"5": {
			"62": [
				62
			],
			"233": [
				233
			],
			"241": [
				241
			],
			"248": [
				248
			],
			"406": [
				406
			],
			"685": [
				676
			]
		},
		"6": {
			"61": [
				61
			],
			"232": [
				232
			],
			"240": [
				240
			],
			"246": [
				246
			],
			"405": [
				405
			],
			"684": [
				675
			]
		},
		"7": {
			"58": [
				58
			],
			"234": [
				234
			],
			"236": [
				236
			],
			"238": [
				238
			],
			"681": [
				672
			]
		},
		"8": {
			"59": [
				59
			],
			"235": [
				235
			],
			"237": [
				237
			],
			"239": [
				239
			],
			"682": [
				673
			]
		}
	},
	"32": {
		"0": {
			"73": [
				73
			],
			"102": [
				102
			],
			"256": [
				256
			],
			"257": [
				257
			],
			"306": [
				306
			],
			"307": [
				307
			],
			"318": [
				318
			],
			"352": [
				352
			],
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"748": [
				739
			]
		},
		"1": {
			"21": [
				21
			],
			"122": [
				122
			],
			"129": [
				129
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"366": [
				366
			],
			"566": [
				557
			],
			"616": [
				607
			]
		},
		"2": {
			"22": [
				22
			],
			"123": [
				123
			],
			"130": [
				130
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"367": [
				367
			],
			"567": [
				558
			],
			"617": [
				608
			]
		},
		"3": {
			"23": [
				23
			],
			"124": [
				124
			],
			"131": [
				131
			],
			"140": [
				140
			],
			"184": [
				184
			],
			"197": [
				197
			],
			"368": [
				368
			],
			"568": [
				559
			],
			"618": [
				609
			]
		},
		"4": {
			"17": [
				17
			],
			"176": [
				176
			],
			"362": [
				362
			]
		},
		"5": {
			"13": [
				13
			],
			"172": [
				172
			],
			"358": [
				358
			]
		},
		"6": {
			"18": [
				18
			],
			"177": [
				177
			],
			"363": [
				363
			]
		},
		"7": {
			"14": [
				14
			],
			"173": [
				173
			],
			"359": [
				359
			]
		},
		"8": {
			"19": [
				19
			],
			"178": [
				178
			],
			"364": [
				364
			]
		},
		"9": {
			"15": [
				15
			],
			"174": [
				174
			],
			"360": [
				360
			]
		}
	},
	"33": {
		"0": {
			"348": [
				348
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"34": {
		"0": {
			"1": [
				1
			],
			"74": [
				74
			],
			"103": [
				103
			],
			"136": [
				136
			],
			"256": [
				256
			],
			"260": [
				260
			],
			"261": [
				261
			],
			"278": [
				278
			],
			"282": [
				282
			],
			"306": [
				306
			],
			"321": [
				321
			],
			"322": [
				322
			],
			"323": [
				323
			],
			"324": [
				324
			],
			"325": [
				325
			],
			"326": [
				326
			],
			"327": [
				327
			],
			"343": [
				343
			],
			"345": [
				345
			],
			"346": [
				346
			],
			"349": [
				349
			],
			"415": [
				415
			],
			"417": [
				417
			],
			"418": [
				418
			],
			"425": [
				425
			],
			"426": [
				426
			],
			"443": [
				443
			],
			"524": [
				515
			],
			"526": [
				517
			],
			"527": [
				518
			],
			"534": [
				525
			],
			"535": [
				526
			],
			"537": [
				528
			],
			"538": [
				529
			],
			"539": [
				530
			],
			"540": [
				531
			],
			"541": [
				532
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			],
			"702": [
				693
			],
			"705": [
				696
			],
			"706": [
				697
			],
			"710": [
				701
			],
			"724": [
				715
			],
			"731": [
				722
			],
			"747": [
				738
			],
			"871": [
				862
			],
			"904": [
				895
			],
			"911": [
				902
			]
		},
		"1": {
			"21": [
				21
			],
			"83": [
				83
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"419": [
				419
			],
			"528": [
				519
			],
			"673": [
				664
			],
			"707": [
				698
			],
			"743": [
				734
			],
			"765": [
				756
			],
			"803": [
				794
			],
			"869": [
				860
			]
		},
		"2": {
			"22": [
				22
			],
			"84": [
				84
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"420": [
				420
			],
			"529": [
				520
			],
			"674": [
				665
			],
			"708": [
				699
			],
			"744": [
				735
			],
			"766": [
				757
			],
			"868": [
				859
			],
			"870": [
				861
			]
		},
		"3": {
			"2": [
				2
			],
			"148": [
				148
			],
			"154": [
				154
			],
			"160": [
				160
			],
			"661": [
				652
			]
		},
		"4": {
			"5": [
				5
			],
			"149": [
				149
			],
			"155": [
				155
			],
			"163": [
				163
			],
			"664": [
				655
			]
		},
		"5": {
			"7": [
				7
			],
			"150": [
				150
			],
			"156": [
				156
			],
			"165": [
				165
			],
			"666": [
				657
			]
		},
		"6": {
			"151": [
				151
			],
			"157": [
				157
			],
			"166": [
				166
			],
			"667": [
				658
			],
			"939": [
				930
			]
		},
		"7": {
			"9": [
				9
			],
			"152": [
				152
			],
			"158": [
				158
			],
			"168": [
				168
			],
			"669": [
				660
			]
		},
		"8": {
			"12": [
				12
			],
			"153": [
				153
			],
			"159": [
				159
			],
			"171": [
				171
			],
			"672": [
				663
			]
		},
		"9": {
			"255": [
				255
			]
		},
		"10": {
			"353": [
				353
			]
		}
	},
	"35": {
		"0": {
			"74": [
				74
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"426": [
				426
			],
			"443": [
				443
			],
			"535": [
				526
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			],
			"710": [
				701
			],
			"731": [
				722
			],
			"742": [
				733
			],
			"871": [
				862
			],
			"911": [
				902
			]
		},
		"1": {
			"21": [
				21
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"673": [
				664
			]
		}
	},
	"36": {
		"0": {
			"74": [
				74
			],
			"256": [
				256
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"443": [
				443
			],
			"608": [
				599
			],
			"610": [
				601
			],
			"615": [
				606
			],
			"656": [
				647
			],
			"698": [
				689
			]
		},
		"1": {
			"21": [
				21
			],
			"195": [
				195
			],
			"673": [
				664
			]
		}
	},
	"37": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"38": {
		"0": {
			"74": [
				74
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"413": [
				413
			],
			"414": [
				414
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"39": {
		"0": {
			"403": [
				403
			],
			"443": [
				443
			],
			"608": [
				599
			]
		}
	},
	"40": {
		"0": {
			"443": [
				443
			],
			"608": [
				599
			],
			"656": [
				647
			],
			"698": [
				689
			]
		}
	},
	"41": {
		"0": {
			"74": [
				74
			],
			"103": [
				103
			],
			"137": [
				137
			],
			"251": [
				251
			],
			"252": [
				252
			],
			"256": [
				256
			],
			"281": [
				281
			],
			"306": [
				306
			],
			"349": [
				349
			],
			"403": [
				403
			],
			"409": [
				409
			],
			"410": [
				410
			],
			"411": [
				411
			],
			"430": [
				430
			],
			"431": [
				431
			],
			"637": [
				628
			],
			"701": [
				692
			],
			"793": [
				784
			],
			"796": [
				787
			]
		},
		"1": {
			"21": [
				21
			],
			"138": [
				138
			],
			"182": [
				182
			],
			"195": [
				195
			],
			"648": [
				639
			],
			"673": [
				664
			],
			"789": [
				780
			],
			"791": [
				782
			],
			"794": [
				785
			]
		},
		"2": {
			"22": [
				22
			],
			"139": [
				139
			],
			"183": [
				183
			],
			"196": [
				196
			],
			"649": [
				640
			],
			"674": [
				665
			],
			"790": [
				781
			],
			"792": [
				783
			],
			"795": [
				786
			]
		},
		"3": {
			"64": [
				64
			],
			"250": [
				250
			],
			"687": [
				678
			]
		},
		"4": {
			"63": [
				63
			],
			"249": [
				249
			],
			"686": [
				677
			]
		}
	},
	"42": {
		"0": {
			"74": [
				74
			],
			"349": [
				349
			],
			"413": [
				413
			],
			"414": [
				414
			],
			"443": [
				443
			],
			"608": [
				599
			]
		},
		"1": {
			"566": [
				557
			],
			"940": [
				1865
			]
		},
		"2": {
			"567": [
				558
			],
			"941": [
				1866
			]
		},
		"3": {
			"568": [
				559
			],
			"942": [
				1867
			]
		},
		"4": {
			"569": [
				560
			],
			"943": [
				1868
			]
		},
		"5": {
			"570": [
				561
			],
			"944": [
				1869
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/grid-control/providers/slot-types-config.json
// module id = 1827
// module chunks = 2